module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-charm-1.70ed3278.jpg";